import { LayoutChangeEvent, Platform, Text, useWindowDimensions, View } from 'react-native'
import { BottomSheetBackdrop, BottomSheetModal } from '@gorhom/bottom-sheet'
import React, { forwardRef, RefObject, useCallback, useMemo, useState } from 'react'
import CheatSheetContent from './CheatSheetContent'
import { styles } from './CheatSheet.styles'
import { ReduceMotion } from 'react-native-reanimated'
import { useMaxWidth } from '../WebWrapper'
import { isNumber } from 'lodash'

const isWeb = Platform.OS === 'web'

export const CheatSheet = forwardRef<BottomSheetModal>((props, ref) => {
  const snapPoints = useMemo(() => ['85%'], [])

  const maxWidth = useMaxWidth()
  const windowDimensions = useWindowDimensions()

  const contentMargin = useMemo(() => {
    if (isWeb) {
      return undefined
    }
    if (!isNumber(maxWidth)) {
      return undefined
    }
    const widthDiff = Math.floor(windowDimensions.width - maxWidth)
    return widthDiff > 0 ? widthDiff * 0.5 : undefined
  }, [maxWidth, windowDimensions])

  const renderBackdrop = useCallback(
    (props: React.ComponentProps<typeof BottomSheetBackdrop>) => (
      <BottomSheetBackdrop {...props} disappearsOnIndex={-1} appearsOnIndex={0} />
    ),
    []
  )

  return (
    <BottomSheetModal
      ref={ref}
      name={'cheatSheetModal'}
      index={0}
      snapPoints={snapPoints}
      enableDynamicSizing={false}
      backdropComponent={renderBackdrop}
      handleStyle={styles.bottomSheetHandleStyle}
      handleIndicatorStyle={styles.bottomSheetIndicatorStyle}
      keyboardBlurBehavior="restore"
      overrideReduceMotion={ReduceMotion.System}
      enableContentPanningGesture={true}
      enableHandlePanningGesture={true}
      enablePanDownToClose={true}
      style={{
        marginHorizontal: isWeb ? 'auto' : undefined,
        maxWidth: maxWidth,
        width: '100%'
      }}
      containerStyle={{
        // NOTE: This is to force a margin for iPads
        marginLeft: contentMargin
      }}
    >
      <CheatSheetContent />
    </BottomSheetModal>
  )
})
